import React, {Component} from 'react';
import converter from 'number-to-words';
import $ from 'jquery';
import moment from 'moment';
import {num, Title, Noun, Pronoun, SubjectVerb, SingularPluralForm} from '../../../../model/Helper';
import PaperSignatories from '../../../../view/PaperSignatories';
import PaperSignatoriesAcknowledgement from '../../../../view/PaperSignatoriesAcknowledgement';
import PaperParty from '../../../../view/PaperParty';
import WitnessBlock from '../../../../view/WitnessBlock';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{
			if($(window).width()>767){
				if(this.isVisible(".header")){
					////console.log("Visible");
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					////console.log("Not visible");
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}
			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {

        let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
    }

    render() {

        let p = this.props.details.property;
        let s = this.props.details.seller;
        let b = this.props.details.buyer;
        let pa = this.props.details.payment;

        let nounSeller = Noun(s, "seller");
        let nounBuyer = Noun(b, "buyer");

        let blankLine = blank_line;

        let title = (Title(p)) ? Title(p) : blankLine;

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            sellerCorporationTin = [];
        this.props.details.seller.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";

        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = [];
        this.props.details.buyer.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : "";
            //buyerCorporationTin = buyer.buyerCorporationTin ? buyer.buyerCorporationTin : "";   

        });

        let priceNumber = num(p.price);		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;
        
        let earnestMoneyAmountNumber = num(p.earnestMoneyAmount);		
        let earnestMoneyAmountText = (typeof parseFloat(p.earnestMoneyAmount) === "number" && parseFloat(p.earnestMoneyAmount)>0) ?
                            converter.toWords(p.earnestMoneyAmount) : 
                            blankLine;

        let earnestMoneyReceived = blankLine;
		if(p.earnestMoneyReceived) {
			earnestMoneyReceived = moment(p.earnestMoneyReceived).format('LL')
        }

        let balance = p.price - p.earnestMoneyAmount - p.downpayment;
        let balanceNumber = num(balance);
        let balanceText = (typeof parseFloat(balance) === "number" && parseFloat(balance)>0) ?
        converter.toWords(balance) : 
        blankLine;
        
        let downpaymentNumber = num(p.downpayment);
        let downpaymentText =(typeof parseFloat(p.downpayment) === "number" && parseFloat(p.downpayment)>0) ?
        converter.toWords(p.downpayment) : 
        blankLine;
        
        let checkPayee = p.checkPayee ? p.checkPayee : blankLine;

        let buyersPayArray = [];
        let sellersPayArray = [];
        pa.capitalGainTax === "seller" ?
            sellersPayArray.push("capital gain tax"):
            buyersPayArray.push("capital gain tax");
        pa.documentaryStampTax === "seller" ?
            sellersPayArray.push("documentary stamp tax"):
            buyersPayArray.push("documentary stamp tax");
        pa.transferTax === "seller" ?
            sellersPayArray.push("transfer tax"):
            buyersPayArray.push("transfer tax");
        pa.registrationFee === "seller" ?
            sellersPayArray.push("registration fee"):
            buyersPayArray.push("registration fee");
        pa.notarialFee === "seller" ?
            sellersPayArray.push("notarial fee") :
            buyersPayArray.push("notarial fee");
        if(pa.hasBroker === "Yes"){
            pa.brokerCommission === "seller" ?
                sellersPayArray.push("broker's commission") :
                buyersPayArray.push("broker's commission");
        }
        pa.creditableWithholdingTax === "seller" ?
            sellersPayArray.push("creditable withholding tax") :
            buyersPayArray.push("creditable withholding tax");
        pa.valueAddedTax === "seller" ?
            sellersPayArray.push("value added tax") :
            buyersPayArray.push("value added tax");
        let sellersPay = sellersPayArray.join(", ");
        let buyersPay = buyersPayArray.join(", ");

        //let earnestMoneyAmount = p.earnestMoneyAmount ? p.earnestMoneyAmount : blankLine;

        // Create this into array so we can use map inside JSX
        let scheduleOfPaymentsDates = [];
        for(let i=0; i<p.monthsToPayBalance; i++) {
            scheduleOfPaymentsDates.push({
                "count": i,
                "amort": (p.price-p.downpayment-p.earnestMoneyAmount)/p.monthsToPayBalance,
                "date": `${moment(p.firstInstallmentDue).add(i, 'month').format('LL')}`
            })
        }

        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>
                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							{this.props.formName}
						</div>

                        <div className="text-uppercase">
                            <p className="no-indent">
                                KNOW ALL MEN BY THESE PRESENTS:
                            </p>
                        </div>

                        <div>
                            <p>
                                This Contract to Sell (hereinafter “Contract”) made and entered into this _______________ in _______________, Philippines, by and between:
                            </p>
                        </div>

                        <PaperParty party={s} type="seller" />

                        <div className="paper-narrow my-3 text-center">
                            <div className="my-3">- and -</div>
                        </div>

                        <PaperParty party={b} type="buyer" />

                        <div className="paper-narrow my-3 text-center">
                            <div className="my-3"><strong>WITNESSETH</strong>: That-</div>
                        </div>

                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounSeller}</span> {SubjectVerb( nounSeller, "is")} the absolute and registered owners of a parcel of land, together with its improvement (hereinafter “Subject Real Property”), situated at <span className="dynamic-data text-capitalize property_address">{p.address}</span>.
                            </p>
                        </div>
                                
                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounSeller}</span> {SubjectVerb(nounSeller, "has")} offered to sell to the <span className="text-uppercase">{nounBuyer}</span>, and the <span className="text-uppercase">{nounBuyer}</span> {SubjectVerb("has", nounBuyer)} agreed to purchase from the <span className="text-uppercase">{nounSeller}</span>, the Subject Real Property;
                            </p>
                        </div>

                        <div>
                            <p>
                                NOW THEREFORE, for and in consideration of the foregoing premises and the terms and conditions hereinafter set forth, the parties hereby agree as follows:
                            </p>
                        </div>

                        <div className="section1 my-3 property_type property_registrationType">
                            <h5 className="my-3">SECTION 1. <u>SUBJECT REAL PROPERTY</u></h5>
                            <p>
                                1.1. &emsp; For and in consideration of the sums of money to be paid in the manner herein below specified, and the undertaking of the <span className="text-uppercase">{nounBuyer}</span> to fully perform and comply with all its obligations, covenants, conditions and restrictions, the <span className="text-uppercase">{nounSeller}</span> hereby agree and contract to sell to the <span className="text-uppercase">{nounBuyer}</span>, and the latter hereby agrees and contracts to buy from the former the Subject Real Property covered by <span className="dynamic-data text-uppercase property_ctn property_tct property_oct">{title}</span>. A copy of the said title is hereto attached and made an integral part of this Contract.  
                            </p> 
                        </div>

                        <div className="section2 my-3">
                            <h5 className="my-3">SECTION 2. <u>PURCHASE PRICE AND TERMS OF PAYMENT</u></h5>
                            <p>
                                2.1. &emsp; The <span className="text-uppercase">{nounBuyer}</span> hereby agrees to pay the <span className="text-uppercase">{nounSeller}</span> the sum of <span className="dynamic-data text-uppercase property_price">{priceText} PESOS (P{priceNumber})</span> Philippine Currency (hereinafter “Purchase Price”), as consideration for the sale of the Subject Real Property.
                            </p>
                            <p className={p.earnestMoney==="Yes"?``:`d-none`}>
                                2.2. &emsp; The Earnest Money of <span className="dynamic-data text-uppercase property_earnestMoney property_earnestMoneyAmount">{earnestMoneyAmountText} PESOS (P{earnestMoneyAmountNumber})</span> Philippine currency, receipt of which was on <span className="dynamic-data property_earnestMoneyReceived">{earnestMoneyReceived}</span>, is hereby acknowledged by the <span className="text-uppercase">{nounSeller}</span>, and shall be applied as part of the downpayment on the Subject Real Property in the aggregate amount of <span className="dynamic-data property_downpayment">{downpaymentText} PESOS (P{downpaymentNumber})</span> Philippine Currency.
                            </p>
                            <p>
                                2.{p.earnestMoney==="Yes"?`3`:`2`}. &emsp; The balance of the Purchase Price, amounting to <span className="dynamic-data text-uppercase">{balanceText} (P{balanceNumber})</span> Philippine Currency, shall be paid in accordance with the attached Schedule of Payment.
                            </p>
                            <p>
                                2.{p.earnestMoney==="Yes"?`4`:`3`}. &emsp; In addition, the <span className="dynamic-data text-uppercase"><span className="text-uppercase">{nounBuyer}</span></span> shall also pay all requisite expenses, fees and charges specified in Section 5.
                            </p>
                            <p>
                                2.{p.earnestMoney==="Yes"?`5`:`4`}. &emsp; The <span className="text-uppercase">{nounBuyer}</span> shall, at the time of the execution of this Contract, issue in favor of "<span className="dynamic-data text-uppercase">{checkPayee}</span>" post-dated checks equivalent to and to coincide with the Schedule of Payment. The receipt of a check in payment shall not produce the effect of payment until the amount thereof is actually encashed or credited by the collecting bank in favor of the <span className="text-uppercase">{nounSeller}</span>.
                            </p>
                        </div>

                        <div className="section3 my-3">
                            <h5 className="my-3 text-uppercase">SECTION 3. <u>DEFAULT OF THE {nounBuyer}</u></h5>
                            <p>
                                3.1. &emsp; If the <span className="text-uppercase">{nounBuyer}</span> fails for any reason to pay any installment when due in accordance with Section 2 hereof, together with any interest thereon as provided in this Contract, the rights and obligations of the parties shall be governed by the relevant laws, rules and regulations including, but not limited to, the provisions of Republic Act No. 6552, or the Realty Installment Buyer Protection Act.
                            </p>
                            <p>
                                3.2. &emsp; Further, the <span className="text-uppercase">{nounSeller}</span> shall, at their own absolute discretion, {SubjectVerb(nounSeller, "has")} the right (i) to charge the <span className="text-uppercase">{nounBuyer}</span> a late payment charge at the rate of three percent (3%)per month or a fraction thereof of the total amount due and payable, computed from the due date of each installment; and/or, (ii) to cancel and rescind this Contract by written notice to the <span className="text-uppercase">{nounBuyer}</span>.
                            </p>
                            <p>
                                3.3. &emsp; If the Contract is cancelled, the actual cancellation shall take place after thirty (30) days from receipt by the <span className="text-uppercase">{nounBuyer}</span> of the notice of cancellation or demand for rescission of this Contract by notarial act.
                            </p>
                            <p>
                                3.4. &emsp; Upon the effectivity of such cancellation or rescission, the <span className="text-uppercase">{nounBuyer}</span> shall,without need of a judicial order, immediately vacate the Subject Real Property and remove at {Pronoun("his", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} expense all furniture and fixtures which may have been placed in the Subject Real Property, otherwise, the same shall form part of and be considered attached to the Subject Real Property and shall become the property of the <span className="text-uppercase">{nounSeller}</span> without any obligation to indemnify the <span className="text-uppercase">{nounBuyer}</span> for the value thereof. Fixtures and improvements which are permanent in nature or which cannot be removed without causing damage to the Subject Real Property shall be considered part of the Subject Real Property and should not be removed therefrom. Should the <span className="text-uppercase">{nounBuyer}</span> or any of {Pronoun("his", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} privies or successors-in-interest, after the effectivity of such cancellation or rescission, continue to be in possession of the Subject Real Property, such person shall become a mere intruder in unlawful detainer of the same, without any further right, title, interest or claim of any kind or character to the Subject Real Property and the improvements, if any.
                            </p>
                            <p>
                                3.5. &emsp; Notice to the <span className="text-uppercase">{nounBuyer}</span>, sent to the address indicated on page 1 hereof, shall be considered as full compliance with the above requirements.
                            </p>
                        </div>

                        <div className="section4 my-3">
                            <h5 className="my-3">SECTION 4. <u>TRANSFER OF TITLE/OWNERSHIP</u></h5>
                            <p>
                                4.1. &emsp; The <span className="text-uppercase">{nounSeller}</span> shall execute or cause the execution of a Deed of Absolute Sale thereby conveying all their rights, title and interest in and to the Subject Real Property upon the payment in full of the Purchase Price.
                            </p>
                        </div>

                        <div className="section5 my-3">
                            <h5 className="my-3 payment_capitalGainTax payment_documentaryStampTax payment_transferTax payment_registrationFee payment_notarialFee payment_brokerCommission payment_creditableWithholdingTax payment_valueAddedTax">SECTION 5. <u>TAXES, FEES AND EXPENSES</u></h5>
                            <p>
                                5.1. &emsp; The <span className="dynamic-data">{buyersPay}</span>, and other necessary expenses connected with this Contract, the Deed of Absolute Sale and the issuance of the corresponding title for the Subject Real Property in the name of the <span className="text-uppercase"><span className="text-uppercase">{nounBuyer}</span></span> shall be for the account of and paid by the <span className="text-uppercase">{nounBuyer}</span>.
                            </p>
                            <p>
                                5.2. &emsp; The <span className="dynamic-data">{sellersPay}</span>, whichever is applicable, shall be for the account of and paid by the <span className="text-uppercase">{nounSeller}</span>.
                            </p>
                            <p>
                                5.3. &emsp; The <span className="text-uppercase">{nounSeller}</span> shall update the real property taxes prior to the delivery of the Subject Real Property. From and after the said delivery, any and all real property taxes accruing on the said property shall be for the account of the <span className="text-uppercase">{nounBuyer}</span>.
                            </p>
                        </div>

                        <div className="section6 my-3">
                            <h5 className="my-3">SECTION 6. <u>DELIVERY OF THE SUBJECT REAL PROPERTY</u></h5>
                            <p>
                                6.1. &emsp; Provided that the <span className="text-uppercase">{nounBuyer}</span> {SubjectVerb(nounBuyer, "is")} in full compliance with the terms and conditions of this Contract, <span className="dynamic-data">{p.possession==="Upon the execution of the Contract to Sell"?`the ${nounSeller.toUpperCase()} shall immediately surrender possession and occupation of the Subject Real Property in favor of the ${nounBuyer.toUpperCase()}.`:`the ${nounSeller} shall, upon execution of the Deed of Absolute Sale, surrender possession and occupation of the Subject Real Property in favor of the ${nounBuyer.toUpperCase()}.`}</span>
                            </p>
                        </div>

                        <div className="section7 my-3">
                            <h5 className="my-3">SECTION 7. <u>ASSIGNMENT</u></h5>
                            <p>
                                7.1. &emsp; The <span className="text-uppercase">{nounBuyer}</span> shall not sell, assign or transfer any of {Pronoun("his", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} rights, interests and obligations in and under this Contract to any person or entity without the prior written consent of the <span className="text-uppercase">{nounSeller}</span>.
                            </p>
                        </div>

                        <div className="section8 my-3">
                            <h5 className="my-3">SECTION 8. <u>GENERAL PROVISIONS</u></h5>
                            <p>
                                8.1. &emsp; The <span className="text-uppercase">{nounBuyer}</span> hereby {SingularPluralForm(nounBuyer, "represent")} that {Pronoun("he", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} authorized representative has read, understood and accepted the entire Contract and that {Pronoun("his", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} execution hereof constitutes a legal, valid and binding obligation, fully enforceable against {Pronoun("him", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} and that {Pronoun("he", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} has full power, authority and legal right to execute, deliver and perform this Contract and the Deed of Absolute Sale.
                            </p>
                            <p>
                                8.2. &emsp; All notices and other communications required or permitted to be given hereunder shall be given in writing, and shall be sent to the appropriate addresses of the parties as indicated on page 1 hereof.
                            </p>
                            <p>
                                8.3. &emsp; This Contract and the rights and obligations of the parties hereunder shall be governed by and construed in accordance with the laws of the Republic of the Philippines.
                            </p>
                            <p>
                                8.4. &emsp; This Contract shall be obligatory and binding upon the heirs, successors in-interest, administrators and assigns of the parties hereto.
                            </p>
                            <p>
                                8.5. &emsp; If at any time before the full payment of the Purchase Price, the government or any of its political subdivisions, instrumentalities or any public service company shall condemn or expropriate the property, the <span className="text-uppercase">{nounSeller}</span> shall have the full and absolute right to deal or negotiate with or resist the expropriating or condemning authority or enter into a compromise with the latter, and the <span className="text-uppercase">{nounBuyer}</span> shall only have a right to receive a portion of the compensation in the same proportion that the total amount paid by the <span className="text-uppercase">{nounBuyer}</span> bears to the Purchase Price, or to a pro-rata reduction of the Purchase Price.
                            </p>
                            <p>
                                8.6. &emsp; If any one or more of the provisions of this Contract is declared invalid or unenforceable in any respect under any applicable law, the validity, legality or enforceability of the remaining provisions contained herein shall not in any way be affected or impaired.
                            </p>
                        </div>
                        
                        <br />
                        <br />

                        <div>
                            <p>
                                IN WITNESS WHEREOF, the parties have executed this Contract on the date and in the place first above written.
                            </p>
                        </div>

                        <br />
                        <br />

                        <div>
                            <PaperSignatories party1={s} party2={b} />
                        </div>

                        <div className="mt-5">
                            <WitnessBlock />
                        </div>

                        <br /><br />

                        <hr />
                        <br /><br />
                        
                        {
                        /**
                         * Acknowledgement section
                         */
                        }
                        <div className="paper-top-left d-inline-block">
							<div>REPUBLIC OF THE PHILIPPINES )</div>
							<div>)S.S.</div>
						</div>

                        <div className="paper-title text-center">
							Acknowledgement
						</div>

                        <div>
                            <p>
                                BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                            </p>
                        </div>

                        {/** All signatories */}
                        <PaperSignatoriesAcknowledgement party1={s} party2={b} />

                        <div>
                            <p>
                                Known to me and to me known to be the same persons who executed the foregoing Contract to Sell consisting of <span className="dynamic-data"><small className="text-muted font-italic">[to be filled up by the system]</small></span> pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                            </p>
                            <p>
                                WITNESS MY HAND AND SEAL in the place and on the date first above written.
                            </p>
                        </div>

                        <br />
                        <br />
                        <div className="docno">
							Doc No. ________; <br />
							Page No. _______; <br />
							Book No. _______; <br />
							Series of 20 ___. <br />
						</div>

                        <br /><br />
                        <hr />
                        <br /><br />
                        
                        {
                        /**
                         * Schedule of payment
                         */
                        }
                        <div className="schedule-of-payment property_possession property_monthsToPayBalance property_firstInstallmentDue">
                            <div className="paper-title text-center">
                                Schedule of Payment
                            </div>
                            <table className="table table-bordered table-sm even3">
                                <tbody>
                                    <tr>
                                        <td>Selling Price</td>
                                        <td className="text-right"><span className="dynamic-data text-uppercase font-weight-bold"><u>{priceNumber}</u></span></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>Term</td>
                                        <td className="text-right"><span className="dynamic-data font-weight-bold property_monthsToPayBalance">{p.monthsToPayBalance}</span></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>Earnest Money</td>
                                        <td className="text-right"><span className="dynamic-data font-weight-bold">{earnestMoneyAmountNumber}</span></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>{Number((p.downpayment/p.price)*100).toLocaleString(undefined, { maximumFractionDigits: 2 })}% Downpayment</td>
                                        <td className="text-right"><span className="dynamic-data font-weight-bold">{downpaymentNumber}</span></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>{Number(100-((p.downpayment/p.price)*100)).toLocaleString(undefined, { maximumFractionDigits: 2 })}% balance within {p.monthsToPayBalance} months</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    {
                                        scheduleOfPaymentsDates.map((obj, i)=>{
                                            return(
                                                <tr key={i}>
                                                    <td className="text-center">{obj.count+1}</td>
                                                    <td className="text-right">{Number(obj.amort).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                                                    <td className="text-right">{obj.date}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>

                            <br />
                            <div>
                                Note: All post-dated checks are required to be payable to <span className="dynamic-data font-weight-bold text-uppercase property_checkPayee">{checkPayee}</span>
                            </div>
                        </div>
                    
                    </div>
                    </div> {/** End of paper */}

                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/contract-to-sell/Preview.js